module.exports = __webpack_public_path__ + "static/img/right-rider.dff8b3c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/right-rider.gif
// module id = wv5R
// module chunks = 8